import { string, number, bool, shape, arrayOf } from 'prop-types';

export const phonePropTypes = {
  id: number,
  type: string,
  number: string,
  carrier: string,
  default: bool
};

export const userInfoPropTypes = {
  emails: arrayOf(
    shape({
      id: number,
      email: string
    })
  ),
  phones: arrayOf(shape(phonePropTypes))
};

export const signUpUserInformation = shape({
  date_of_birth: string.isRequired,
  mobile: shape({
    carrier: string,
    number: string.isRequired,
    default: bool
  }).isRequired,
  document_type: string,
  document_number: string,
  last_name: string.isRequired,
  first_name: string.isRequired,
  phone: shape({
    number: string.isRequired
  }).isRequired
});
